import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPost from "../axios/axios-post";

export const FileAPI = Object.freeze({
  postUploadFiles: createAsyncThunk(
    "post/upload-file",
    async (formdata, { rejectWithValue }) => {
      try {
        const response = await axiosPost.post("/upload-file", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),
});
